import { Component, Watch, Vue } from 'vue-property-decorator';

@Component
export default class PageReviewMixin extends Vue {
  // Data
  reviewError: string = '';
  reviewPopup: boolean = false;
  reviewResult: boolean = false;
  closeModal: boolean = false;
  localReviews: Array<any> = [];

  // Computed
  get reviews() {
    return this.localReviews;
  }

  // Watcher
  @Watch('reviewPopup')
  setReviewResult() {
    this.reviewResult = false;
  }

  // Methods
  async closePopup() {
    const {
      reviewPopup,
      $route: { name },
    } = this;
    if (reviewPopup && name !== 'blog-article') await this.loadReviews();
    if (this.closeModal) this.closeModal = false;

    this.reviewPopup = false;
    this.reviewError = '';
  }

  async loadReviews() {
    throw new Error('You need redefine method "loadReviews"');
  }
}



// WEBPACK FOOTER //
// ./src/pages/review-mixin.ts